<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2023-02-06 15:56:24
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2024-06-07 14:37:03
-->
<template>
  <div class="innovative innovative-aneushape" :class="{text: language != 'en'}" ref="aneushape">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/pc/innovate/product-list-bj.png')" alt="" srcset="">
      <div class="innovative-bj-title center_up_down_left_right" v-html="$t('product.aneushape.title')"></div>
    </div>
    <div class="p-t-60 overhid">
      <div class="innovative-container">
        <div class="innovative-wrap-item flex p-b-150" :class="{align_items_center: language != 'en'}">
          <div class="flex_1">
            <img class="" :src="$t('product.aneushape.list[0].img')" alt="" srcset="">
          </div>
          <div class="flex_1 p-l-80">
            <div class="innovative-item-title" v-html="$t('product.aneushape.list[0].title')"></div>
            <div class="p-t-46 p-b-30 textj">
              <p v-for="(item, index) in $t('product.aneushape.list[0].des')" :key="index" v-html="item"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="innovative-wrap-item p-t-0 posrel aneushape-characteristics">
        <img v-if="language != 'en'" class="wh100" :src="$t('product.aneushape.list[1].img')" alt="" srcset="">
        <div class="t-0 wh100 innovative-container p-t-50 p-b-50" :class="language != 'en' ? 'posabs' : ''">
          <div class="innovative-characteristics trans-list wh100 flex flex_col" :class="{en: language == 'en'}">
            <div class="innovative-item-title" v-html="$t('product.aneushape.list[1].title')"></div>
            <div class="p-t-40 flex_1 flex align_items_center wid100">
              <div class="flex justify_content_between wid100">
                <div class="flex_1 flex flex_col align_items_center" :class="index == 0 ? 'p-r-20' : ''" v-for="(item, index) in $t('product.aneushape.list[1].des')" :key="index">
                  <div :class="['flex flex_col align_items_center', index == 1 ? 'p-r-40' : '']">
                    <img class="" :src="item.img" alt="" srcset="">
                    <div class="innovative-wrap-item-title fz-22 p-b-28 p-t-15" v-html="item.title"></div>
                  </div>
                  <div>
                    <p class="innovative-characteristics-item" v-for="($item, $index) in item.list" :key="$index" v-html="$item"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="aneushape-advantages">
        <div class="innovative-container">
          <div class="innovative-aneushape-m-h trans-list">
            <div class="innovative-item-title m-l-35 m-t-14 m-b-16 p-l-15 ilblk widauto p-r-60" v-html="$t('product.aneushape.list[2].title')"></div>
            <div class="flex justify_content_center p-t-50 p-b-20 p-l-35 p-r-20">
              <img class="wid100" :src="$t('product.aneushape.list[2].img')" alt="" srcset="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="innovative-container">
      <div class="innovative-wrap-item p-t-50 p-b-50 article">
        <div class="innovative-item-title" v-html="$t('product.aneushape.article.title')"></div>
        <div class="p-t-15">
          <p class="p-t-15" v-for="(item, index) in $t('product.aneushape.article.des')" :key="index" v-html="`${index + 1}. ${item}`"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['language', 'scrollTop', 'clientHeight'])
  }
}
</script>

<style lang="less">
@import "~@/styles/pc/products.less";
</style>

<style lang="less" scoped>
.pc .innovative-aneushape {
  .innovative-characteristics {
    padding: 32PX 125PX 50PX 60PX;
    min-height: 400PX;
    &.en {
      padding-right: 60PX;
    }
  }
  .aneushape-advantages {
    background: #F8FBFF;
    padding: 50PX 0;
  }
  .innovative-aneushape-m-h {
    background: #FFFFFF;
    box-shadow: 0PX 4PX 12PX 4PX rgba(81, 170, 255, 0.1);
    padding: 30PX;
    font-size: 24PX;
    font-weight: 600;
  }
}
.pc.en .innovative-aneushape {
  .aneushape-characteristics {
    background-image: url('~@/assets/images/innovate/AneuShape/2.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
}
</style>
<style lang="less" scoped>
@media screen and (max-width: 1650PX) {
  .pc.zh .innovative-aneushape {
    .aneushape-characteristics {
      height: 500PX;
    }
  }
}
</style>
